import React from 'react'
import MBank from '../../Images/MobileBanking/MobileBanking.JPG'
import '../../css/mobilebanking.css'

const MobileBankingService = () => {
    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='branches-top'>
                        <div className='welcome-title-center'>
                            <h2><span>कनकलक्ष्मी साकोस :: मोबाइल बैङकिङ सेवा</span></h2>
                        </div>
                    </div>
                    <div className='body'>
                        <div className='mbservice-body'>
                            <div className='mbservice-content'>
                                <div className='mbservice-heading'>
                                    <h3><span>विशेषताहरू :</span></h3>
                                </div>
                                <div className='mbservice-main'>
                                    <ul>
                                        <li>खाताबाट खातामा रकम सार्ने सेवा</li>
                                        <li>ल्याण्डलाइन तथा मोवाईल रिचार्ज सेवा</li>
                                        <li>विभिन्न वालेट लोड सेवा</li>
                                        <li>सरकारी तथा अर्ध सरकारी निकायमा कर भुक्तानी सेवा</li>
                                        <li>ईन्टरनेट, विजुली, पानी लगायत अन्य धेरै विल भुक्तानी सेवा</li>
                                        <li>हवाइजहाज तथा बस टिकट खरिद सेवा</li>
                                        <li>ईन्स्योरेन्स प्रिमियम भुक्तानी सेवा</li>
                                        <li>बैँकबाट संस्थाको खातामा र संस्थाको खाताबाट बैँक खातामा रकम सार्न मिल्ने सेवा</li>
                                        <li>QR Scan सेवा</li>
                                        <li>संस्थाको एक सदस्यको खाताबाट अर्को सदस्यको खातामा रकम सार्न मिल्ने सेवा</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='mbservice-img'>
                            <img src={MBank} alt='MobileBanking' />
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default MobileBankingService